<template>
    <body class="min-h-fullscreen bg-home center-vh p-20" data-overlay="7">

        <div class="card px-50 py-30 w-400px mb-0" >
            <img src="../../assets/static/logo.png" alt="logo icon">
            <circle-spin class="mt-20" v-if="loading"></circle-spin>
            <div v-else>
                <br>
                <p>{{message}}. Proceed to log in</p>
                <p>
                <router-link tag="a" to="/" href='#' class="btn btn-bold btn-primary">
                Log in
                <span class="ion-arrow-right-c"></span>
                </router-link>
                </p>
            </div>

        </div>
</body>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            loading: true,
            message: ''
        }
    }, 
    mounted() {
        let cipher = this.$route.params.cipher
        axios.get(`/users/verify/email/${cipher}`)
        .then(res => {
            this.loading = false
            this.message = res.data.data
            // console.log(res)
        })
        .catch(err => {
                // this.loading= false
                this.$notify({
                group: 'response',
                type: 'error',
                title: `${err.response.data.message}. Please try again`,
                duration: 2500       
                });
                setTimeout(() => {
                    this.$router.push('/')
                }, 3000)
            })
    }
}
</script>
